module.exports = __webpack_public_path__ + "static/media/paint-roller.f2febe46.svg";